/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceSearchDto
 */
export interface InvoiceSearchDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceSearchDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSearchDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSearchDto
     */
    invoiceNumber?: string | null;
}

/**
 * Check if a given object implements the InvoiceSearchDto interface.
 */
export function instanceOfInvoiceSearchDto(value: object): value is InvoiceSearchDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InvoiceSearchDtoFromJSON(json: any): InvoiceSearchDto {
    return InvoiceSearchDtoFromJSONTyped(json, false);
}

export function InvoiceSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSearchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'invoiceNumber': json['invoiceNumber'] == null ? undefined : json['invoiceNumber'],
    };
}

export function InvoiceSearchDtoToJSON(json: any): InvoiceSearchDto {
    return InvoiceSearchDtoToJSONTyped(json, false);
}

export function InvoiceSearchDtoToJSONTyped(value?: InvoiceSearchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'invoiceNumber': value['invoiceNumber'],
    };
}

